import { Entity, LoadingState } from '@zdr-tools/zdr-entities';
/** Where the "New trip" dialog is. */
export var TripCreationStep;
(function (TripCreationStep) {
    /** No dialog. */
    TripCreationStep["CLOSED"] = "CLOSED";
    /** The dialog is open for typing. */
    TripCreationStep["EDITING"] = "EDITING";
    /** The create request is in flight; the dialog cannot be closed. */
    TripCreationStep["CREATING"] = "CREATING";
})(TripCreationStep || (TripCreationStep = {}));
/** Why the last attempt did not create a trip. */
export var TripCreationFailure;
(function (TripCreationFailure) {
    TripCreationFailure["NONE"] = "NONE";
    /** Empty, only spaces, or too long (refused before sending, or by the server). */
    TripCreationFailure["INVALID_TITLE"] = "INVALID_TITLE";
    /** The server could not be reached or failed. */
    TripCreationFailure["UNAVAILABLE"] = "UNAVAILABLE";
})(TripCreationFailure || (TripCreationFailure = {}));
const NO_ATTEMPT_KEY = '';
/** The "New trip" dialog: whether it is open, the create request's state, and the attempt being retried. */
export class TripCreation extends Entity {
    loadingState;
    step;
    failure;
    failureRevision;
    attemptTitle = '';
    attemptKey = NO_ATTEMPT_KEY;
    constructor() {
        super('trip-creation');
        this.loadingState = this.createPropEventBroker('loadingState', LoadingState.IDLE);
        this.step = this.createPropEventBroker('step', TripCreationStep.CLOSED);
        this.failure = this.createPropEventBroker('failure', TripCreationFailure.NONE);
        this.failureRevision = this.createPropEventBroker('failureRevision', 0);
    }
    getEntityName() {
        return 'TripCreation';
    }
    open() {
        if (this.step.get() !== TripCreationStep.CREATING) {
            this.forgetAttempt();
            this.failure.set(TripCreationFailure.NONE);
            this.loadingState.set(LoadingState.IDLE);
            this.step.set(TripCreationStep.EDITING);
        }
    }
    close() {
        if (this.step.get() === TripCreationStep.EDITING) {
            this.forgetAttempt();
            this.step.set(TripCreationStep.CLOSED);
        }
    }
    markInvalidTitle() {
        this.recordFailure(TripCreationFailure.INVALID_TITLE);
    }
    markCreating(normalizedTitle, freshKey) {
        const isRetry = this.attemptKey !== NO_ATTEMPT_KEY && this.attemptTitle === normalizedTitle;
        if (!isRetry) {
            this.attemptTitle = normalizedTitle;
            this.attemptKey = freshKey;
        }
        this.failure.set(TripCreationFailure.NONE);
        this.loadingState.set(LoadingState.LOADING);
        this.step.set(TripCreationStep.CREATING);
        return this.attemptKey;
    }
    markCreated() {
        this.forgetAttempt();
        this.loadingState.set(LoadingState.DONE);
        this.step.set(TripCreationStep.CLOSED);
    }
    markFailed(failure) {
        this.recordFailure(failure);
        this.loadingState.set(LoadingState.ERROR);
        this.step.set(TripCreationStep.EDITING);
    }
    recordFailure(failure) {
        this.failure.set(failure);
        this.failureRevision.set(this.failureRevision.get() + 1);
    }
    forgetAttempt() {
        this.attemptTitle = '';
        this.attemptKey = NO_ATTEMPT_KEY;
    }
}
//# sourceMappingURL=TripCreation.js.map